import { Box, Stack } from '@mui/material';
import { Button } from 'system/atoms';
import { Paths } from 'services/navigation/paths';
import { useNavigate } from 'react-router-dom';
import { useDrawerV2 } from 'common/drawer/hooks/useDrawerV2';
import { TablePagination } from '@mui/material';
import { AlertCard } from 'common/ui';
import {
  SOURCING_ALERT_TYPE,
  SOURCING_STATUS_MESSAGES,
  SOURCING_STATUS_SUB_TITLE
} from 'modules/sourcing-shared/utils/mapSourcingStatuses';
import { mapSourcingStatuses } from 'modules/sourcing-shared/utils/mapSourcingStatuses';
import { ConversationDetails } from 'modules/conversations/components/ConversationDetails';
import { SourcedCandidateQueryItem } from 'modules/sourcing-external/types/SourcedCandidateQueryItem';

export const SourcingCandidateDetailsDrawer: React.FC<{
  candidateBatchId: string;
  candidate: SourcedCandidateQueryItem;
  sourcedCandidates: SourcedCandidateQueryItem[];
  index: number;
  onPageChange: (page: number) => void;
}> = ({
  candidateBatchId,
  candidate,
  sourcedCandidates,
  index,
  onPageChange
}) => {
  const sourcingStatus = mapSourcingStatuses(candidate.status);
  const navigate = useNavigate();
  const { closeDrawer } = useDrawerV2();
  return (
    <Stack
      height="100%"
      sx={{
        overflow: 'hidden'
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          {candidate.candidateId && (
            <Button
              variant="tertiary"
              sx={{
                px: 0
              }}
              onClick={() => {
                closeDrawer();
                navigate(
                  `${Paths.ANALYSE}/${candidateBatchId}?tab=Candidates_with_minimum_requirements&candidateId=${candidate.id}`
                );
              }}
            >
              View in analysis
            </Button>
          )}
        </Box>
        <TablePagination
          component="div"
          labelDisplayedRows={({ from, count }) => `${from} of ${count}`}
          count={sourcedCandidates.length}
          page={index}
          rowsPerPage={1}
          rowsPerPageOptions={[]}
          onPageChange={(_, page) => onPageChange(page)}
        />
      </Stack>
      {sourcingStatus !== 'INVITE_SENT' && (
        <AlertCard
          sx={{
            mt: 2
          }}
          type={SOURCING_ALERT_TYPE[sourcingStatus]}
          title={SOURCING_STATUS_MESSAGES[sourcingStatus]}
          isLoading={sourcingStatus === 'CHECKING_PROFILE'}
        >
          {SOURCING_STATUS_SUB_TITLE[sourcingStatus]}
        </AlertCard>
      )}
      {candidate.conversationId && (
        <ConversationDetails
          conversationId={candidate.conversationId}
          shouldHideApplicationStage
          shouldHideCandidateDetails
          shouldHideScreeningInProgress
        />
      )}
    </Stack>
  );
};
